import selectInsurance from 'utils/selectInsurance';
import getPatientDob3 from 'utils/print/getPatientDob3';

const getInsuranceInsuredsDob3 = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  switch (selectedInsuranceRelationToInsured) {
    case 'Self':
      return getPatientDob3({
        ...otherProps,
        patient,
        insurance,
      });
    case 'Spouse':
    case 'Child':
    case 'Other':
      return selectedInsurance['Related Date of Birth']
        ? selectedInsurance['Related Date of Birth'].replace(/[/]/g, '').substring(6, 8)
        : null;
    default:
      return null;
  }
};

export default getInsuranceInsuredsDob3;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsDob3.js